/* Stride & Summit — light interactivity */
(function () {
  // Mobile menu toggle
  const toggle = document.querySelector('.header-actions__menu-toggle');
  const menu = document.getElementById('MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      const open = menu.hasAttribute('hidden') ? false : true;
      if (open) {
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        menu.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // Pre-fill message field on order form page from ?product= param
  const urlParams = new URLSearchParams(window.location.search);
  const productParam = urlParams.get('product');
  if (productParam) {
    const messageField = document.querySelector('#ContactMessage');
    if (messageField && !messageField.value) {
      messageField.value = 'I\'m interested in: ' + productParam;
    }
  }
})();
